import { rawTimeZones } from "@vvo/tzdb";
import { AutocompleteField } from "./AutocompleteField.js";

const OPTIONS = rawTimeZones.map(zone => ({
  label: zone.rawFormat,
  value: zone.name,
}));

interface Props {
  name: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
}

export const TimeZoneField = ({ name, label, required, disabled }: Props) => {
  return (
    <AutocompleteField
      name={name}
      options={OPTIONS.map(option => option.value)}
      getOptionLabel={option => {
        return OPTIONS.find(o => o.value === option)?.label ?? "";
      }}
      isRequired={required}
      disabled={disabled}
      inputLabel={label}
    />
  );
};
